// extracted by mini-css-extract-plugin
export default {"banner":"TestModeBanner_banner__mxJCf","dot":"TestModeBanner_dot__3bzz2","text":"TestModeBanner_text__tfwYd","action":"TestModeBanner_action__7Sf7R"};